$(function () {
    const $document = $(document);

    $document.ready(() => {
        $('.modal-toggler').click(function () {
            const $this = $(this);
            const $body = $('body');
            const $modal = $($this.attr('data-modal-id'));

            if (!$modal.length) {
                return;
            }

            $body.addClass('body-modal-opened').css('padding-right', getScrollbarWidth() + 'px');

            $modal.fadeIn();

            $modal.find('.modal-close').one('click', () => {
                $modal.fadeOut(null, () => {
                    $body.removeClass('body-modal-opened').css('padding-right', '0');
                });
            });

            return false;
        });

        // TODO Что за код и зачем он здесь?
        $('.slider-toggler').click(function () {
            const $this = $(this);
            $this.toggleClass('expanded').next('.slider-content').slideToggle();
        });
    });
});




// WEBPACK FOOTER //
// ./resources/assets/js/markup.js